import { Injectable } from '@angular/core';
import { Router, CanActivate } from '@angular/router';
import { CognitoService } from './../../services/cognito/cognito.service';

@Injectable()
export class AuthGuard implements CanActivate {
  constructor(public router: Router,  private cognitoService: CognitoService) { }

  canActivate(): boolean {
    if (!this.cognitoService.isAuthenticated()) {
      this.router.navigate(['/']);

      return false;
    }

    return true;
  }
}



// WEBPACK FOOTER //
// ./src/app/route-guards/auth/auth.guard.ts